exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a{cursor:pointer}body{background-color:#fff}.ui.menu .item img.logo{margin-right:1.5em}.main.container{margin-top:7em}.wireframe{margin-top:2em}.ui.footer.segment{margin:5em 0 0;padding:5em 0}.ui.fluid.positive.button.reqbutton,.ui.fluid.primary.button.reqbutton,.ui.fluid.secondary.button.reqbutton{margin-bottom:.5em;margin-top:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9e87f57c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue
// module id = 97
// module chunks = 1